/**
 * @file createOptionalContext
 * @author yuzong(yuzong@tencent.com)
 */
import React from 'react';
export function createOptionalContext(displayName) {
  var Context = React.createContext(null);
  Context.displayName = displayName;

  function useContext() {
    return React.useContext(Context);
  }

  return [Context.Provider, useContext];
}